import { useSelector } from "react-redux";

import { RootState } from "store/rootReducer";

/**
 * Simple hook to access system status from Redux state.
 * Use this for components that only need to read the current status
 * without managing polling (e.g., avatar indicator, banner, menu item).
 */
export function useSystemStatusSelector() {
  const systemStatus = useSelector(
    (state: RootState) =>
      state.app.systemStatus || {
        currentStatus: null,
        lastChecked: null,
        isPolling: false,
        hasActiveIssue: false
      }
  );

  return {
    currentStatus: systemStatus.currentStatus,
    isPolling: systemStatus.isPolling,
    lastChecked: systemStatus.lastChecked,
    hasActiveIssue: systemStatus.hasActiveIssue
  };
}
